<template>
<div>
    <locationnetworksummarypage
    v-if="loaded"
    :locationnetwork="locationNetwork"
    :fnopackages="fnoPackages"
    :currentisppackages="ispPackages"
    :packagetemplates="packageTemplates"
    :totalrevenue="totalRevenue"
    :totalcost="totalCost"
    :totalgp="totalGP"
    :soldpackages="totalPackagesSold"
    :unusedfnopackages="unusedFnoPackages"
    :totalunits="numberOfUnits"
    :activeinstalls="activeInstalls"
    :passiveinstalls="passiveInstalls"
    :isplocationnetwork="ispLocationNetwork"
    @refresh="initialize()"
    />
</div>
</template>
<script>
import Api from "@/services/Api";
import LocationNetworkPackageSummary from "@/components/LocationNetworkPackageSummary.vue";
export default {
    components: {
        locationnetworksummarypage: LocationNetworkPackageSummary
    },
    data(){
        return{
            locationNetwork: {},
            fnoPackages: [],
            fnoPackagesIdArray: [],
            ispPackages: [],
            packageTemplates: [],
            activeServiceAccounts: [],
            totalRevenue: 0,
            totalCost: 0,
            totalPackagesSold: 0,
            totalGP: 0,
            loaded: false,
            unusedFnoPackages: [],
            numberOfUnits:0,
            passiveInstalls: 0,
            activeInstalls: 0,
            ispLocationNetwork: []
        }
    },
    created(){
        this.initialize()
    },
    methods: {
        async initialize(){
            this.loaded=false
            this.fetchLocationNetwork();
            await this.fetchIspPackages();
            this.fetchIspPackageTemplates();
            await this.fetchIspPackageSold()
            
        },
        async fetchLocationNetwork(){
            await Api()
            .get('/customer/ispLocationNetwork/byNetwork/'+this.$route.params.locationNetworkId)
            .then(async response=>{
                this.ispLocationNetwork=response.data
                this.locationNetwork=response.data[0].locationNetwork
                this.fnoPackages=[]
                this.fnoPackagesIdArray=[]
                this.numberOfUnits=response.data[0].locationCount
                this.passiveInstalls=response.data[0].passiveInstallCount
                this.activeInstalls=response.data[0].activeInstallCount
                for (let i=0; i< response.data.length;i++){
                    if(!this.fnoPackagesIdArray.includes(response.data[i].packagesFnoId)&&response.data[i].isActive&&!response.data[i].isDeleted&&response.data[i].packagesFno.isActive&&!response.data[i].packagesFno.isDeleted&&new Date(response.data[i].packagesFno.startDate)< new Date()&&(new Date(response.data[i].packagesFno.endDate)>=new Date()||(response.data[i].packagesFno.endDate == null))){
                        await this.fnoPackages.push(response.data[i].packagesFno)
                        await this.fnoPackagesIdArray.push(response.data[i].packagesFnoId)
                    }
                }
                
            })
        },
        async fetchIspPackages(){
            await Api()
            .get('/customer/packagesIsps/byNetwork/'+this.$route.params.locationNetworkId)
            .then(async response=>{
                this.ispPackages=response.data
                })
        },
        fetchIspPackageTemplates(){
            Api()
            .get('/customer/packagesIspTemplate')
            .then(response=>{
                this.packageTemplates=response.data
            })
        },
        fetchIspPackageSold(){
            this.totalRevenue=0
            this.totalCost=0
            this.totalGP=0
            this.totalPackagesSold=0
            this.unusedFnoPackages=[]
            Api()
            .get('/customer/serviceAccounts/active/byNetwork/'+this.$route.params.locationNetworkId)
            .then(async response=>{
                this.activeServiceAccounts=response.data
                let usedFnoPackages=[]
                for (let i=0; i< this.ispPackages.length; i++){
                    if(this.ispPackages[i].isActive){
                        usedFnoPackages.push(this.ispPackages[i].packagesFnoId)
                    }
                    
                    let id =this.ispPackages[i].id
                    let packages = await this.activeServiceAccounts.filter(function(el){
                        return el.packagesIspId === id
                    })
                    this.ispPackages[i].packageCount = packages.length
                    this.ispPackages[i].estimatedRevenue = packages.length*this.ispPackages[i].recurringPriceVatInc
                    this.ispPackages[i].estimatedCost=packages.length*this.ispPackages[i].packagesFno.packageBasePrice*(1+$VAT)
                    this.ispPackages[i].estimatedGP=this.ispPackages[i].estimatedRevenue-this.ispPackages[i].estimatedCost
                    this.totalRevenue +=  this.ispPackages[i].estimatedRevenue
                    this.totalCost +=  this.ispPackages[i].estimatedCost
                    this.totalGP +=  this.ispPackages[i].estimatedGP
                    this.totalPackagesSold +=  this.ispPackages[i].packageCount
                }
                for (let x=0; x<this.fnoPackagesIdArray.length;x++){
                    if(!usedFnoPackages.includes(this.fnoPackagesIdArray[x])){
                        await this.unusedFnoPackages.push(this.fnoPackages[x])
                    }
                }
                await this.ispPackages.sort((a,b) => (a.packagesFno.speedProfile.downloadMbps > b.packagesFno.speedProfile.downloadMbps) ? 1 : ((b.packagesFno.speedProfile.downloadMbps > a.packagesFno.speedProfile.downloadMbps) ? -1 : 0));
            this.loaded=true
            })
        }
    }
}
</script>